import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ServicesType } from '../../bmcore-services-block/bmcore-services-block.component'

@Component({
  selector: 'bmcore-services-page',
  templateUrl: 'bmcore-services-page.component.html',
  styleUrls: ['bmcore-services-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreServicesPageComponent implements OnInit {
  lg: LgType
  services: Array<ServicesType> = [
    {
      id: 1,
      title: 'Сведение и мастеринг',
      description:
        'Короткое редактируемое продюсером описание, с ограничением по символам, чтобы всё умещалось в одну-две строки. Идейные соображения высшего порядка, также требуют от нас анализа дальнейших направлений развития.',
      price: 1000,
      src: 'service-stub-1.jpg'
    },
    {
      id: 2,
      title: 'Совместный бит с ProducerName',
      description:
        'Короткое редактируемое продюсером описание, с ограничением по символам, чтобы всё умещалось в одну-две строки. Идейные соображения высшего порядка, также требуют от нас анализа дальнейших направлений развития.',
      price: 2500,
      src: 'service-stub-2.jpg'
    },
    {
      id: 3,
      title: 'Дистрибуция',
      description:
        'Короткое редактируемое продюсером описание, с ограничением по символам, чтобы всё умещалось в одну-две строки. Идейные соображения высшего порядка, также требуют от нас анализа дальнейших направлений развития.',
      price: 600,
      src: 'service-stub-3.jpg'
    },
    {
      id: 4,
      title: 'Текст на заказ',
      description:
        'Короткое редактируемое продюсером описание, с ограничением по символам, чтобы всё умещалось в одну-две строки. Идейные соображения высшего порядка, также требуют от нас анализа дальнейших направлений развития.',
      price: 1900,
      src: 'service-stub-4.jpg'
    }
  ]

  constructor(private i18nService: I18nService) {}

  ngOnInit() {
    this.lg = this.i18nService.getLanguageForPage()
    this.getServices()
  }

  getServices() {
    return this.services
  }
}
